// extracted by mini-css-extract-plugin
export default {"inner":"ZrYFa","tabs":"M4QDq"};